import { BaseModel, RecursivePartial } from "@models/base";

export enum VzParamOldTriggerActionType {
    HideParam      = 1,
    ShowParam      = 2,
    SetValue       = 3,
    ArrayNextOrAdd = 4,
    UpdateTplVars  = 5,
    UpdateEnum     = 6,
}

export class VzParamOldTriggerAction extends BaseModel {
    static Type = VzParamOldTriggerActionType;

    type!: VzParamOldTriggerActionType;
    paramId?: string;
    value?: any;

    constructor(json?: RecursivePartial<VzParamOldTriggerAction>) {
        super(json);
        this.parseUnreadCounters(json || {});
    }

    parse(json: RecursivePartial<VzParamOldTriggerAction>): VzParamOldTriggerAction {
        super.parse(json);
        this.parseUnreadCounters(json);
        return this;
    }

    private parseUnreadCounters(json: RecursivePartial<VzParamOldTriggerAction>): void {
        VzParamOldTriggerAction.assignFields<VzParamOldTriggerAction>(this, json, [
            'type',
            'paramId',
            'value'
        ]);
    }
}
